export const PIXEL_ID = '2832673310418578'

let initialized = false

// Minimal typing for the global fbq function injected by the Meta Pixel base code.
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: (...args: unknown[]) => void
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/**
 * Injects the official Meta (Facebook) Pixel base code, initializes the pixel
 * and tracks the initial PageView. Safe to call multiple times.
 *
 * Everything is wrapped in try/catch so that a failure in the pixel (blocked
 * script, ad-blocker, CSP, missing <script> tag, etc.) can NEVER break the
 * rendering of the page itself.
 */
export function initPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true
  try {
    /* eslint-disable */
    ;(function (f: any, b, e, v, n?: any, t?: any, s?: any) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      // Safe insertion: fall back to <head> / <body> if no <script> exists yet.
      s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        ;(b.head || b.body || b.documentElement).appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */
    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
  } catch (err) {
    // Never let pixel errors crash the app.
    console.warn('Meta Pixel failed to initialize:', err)
  }
}

/**
 * Tracks a standard Meta Pixel event (e.g. "InitiateCheckout", "Purchase").
 * Wrapped in try/catch so tracking failures never affect navigation.
 */
export function trackPixel(event: string, data?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  try {
    if (!initialized) initPixel()
    window.fbq?.('track', event, data)
  } catch (err) {
    console.warn('Meta Pixel track failed:', err)
  }
}
